
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ReviewsHero from './components/ReviewsHero';
import ReviewsList from './components/ReviewsList';
import ReviewsFilters from './components/ReviewsFilters';
import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

interface Review {
  id: string;
  title: string;
  content: string;
  verdict: string;
  author: string;
  category: string;
  genre: string;
  featured: boolean;
  published: boolean;
  bestseller: boolean;
  rating: number;
  cover_image: string;
  created_at: string;
  updated_at: string;
}

export default function ReviewsPage() {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [selectedGenre, setSelectedGenre] = useState<string>('All');
  const [selectedRating, setSelectedRating] = useState<number>(0);
  const [showBestsellers, setShowBestsellers] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const { data, error } = await supabase
        .from('posts')
        .select('*')
        .eq('published', true)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching reviews:', error);
      } else {
        setReviews(data || []);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ReviewsHero />
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <aside className="lg:col-span-1">
              <ReviewsFilters
                reviews={reviews}
                selectedCategory={selectedCategory}
                selectedGenre={selectedGenre}
                selectedRating={selectedRating}
                showBestsellers={showBestsellers}
                onCategoryChange={setSelectedCategory}
                onGenreChange={setSelectedGenre}
                onRatingChange={setSelectedRating}
                onBestsellerToggle={setShowBestsellers}
              />
            </aside>
            <div className="lg:col-span-3">
              <ReviewsList
                selectedCategory={selectedCategory}
                selectedGenre={selectedGenre}
                selectedRating={selectedRating}
                showBestsellers={showBestsellers}
              />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
